import React, { useEffect } from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';

import Icon from 'components/shared/Icon/Icon';

import { useSubModal } from '../../lib/SubModalContext';

const ModalDetails = ({ tab, setDetails, details, alwaysShowDetails, showDetails }) => {
  const { device } = useUIContext();
  const { openSubModal, closeSubModal } = useSubModal();
  const isDesktop = device === 'desktop' || device === 'laptop';

  const title =
    typeof tab.details?.title === 'function'
      ? tab.details.title(details)
      : (tab.details?.title ?? details?.name ?? 'Item');

  const showMobilePreview = showDetails && !isDesktop && !!tab?.details?.component;

  useEffect(() => {
    if (showMobilePreview && openSubModal) {
      openSubModal({
        title: (
          <>
            Preview of:
            <span className="ml-2 text-sm font-medium text-neutral-800">{title}</span>
          </>
        ),
        className: 'p-6',
        content: (
          <tab.details.component
            data={typeof details === 'object' && details !== null ? details : {}}
          />
        ),
        actions: {
          onClose: () => {
            setDetails(null);
            closeSubModal();
          }
        }
      });
    }
  }, [showMobilePreview, details]);

  return (
    <>
      {isDesktop && showDetails && tab?.details?.component && (
        <div className="flex h-full w-full flex-col border-0 border-l border-solid border-neutral-200 bg-white transition-all">
          <div className="flex w-full items-center justify-between border-0 border-b border-solid border-neutral-100 px-4 py-2">
            <p className="py-1 text-sm text-neutral-600">
              Preview of:
              <span className="ml-2 text-sm font-medium text-neutral-800">{title}</span>
            </p>
            {!alwaysShowDetails && (
              <Icon
                icon="close-linear"
                className="cursor-pointer"
                onClick={() => setDetails(null)}
              />
            )}
          </div>
          <div className="flex w-full flex-1 justify-center overflow-y-auto bg-neutral-50 p-6">
            <tab.details.component data={details} />
          </div>
        </div>
      )}
    </>
  );
};

export default ModalDetails;
